module.exports = __webpack_public_path__ + "../../static/vue/img/finished.dfcb5dad.png";